import React from "react";
import CoverUpScreen from "./CoverUpScreen";
import DiscoveryScreen from "./DiscoveryScreen";
import DoublesDiceScreen from "./DoublesDiceScreen";

const ActivePlayer = ({
  diceData,
  screens,

  roomId,
  currentPlayer,
  discard_pile,
  OtherPlayers,
  CoverUpData,
  playersWithCard,
  playersWithCardInfo,
  playerSelected,
  cardSelected,
  stealButton,buzzer_sound,default_audio_effect
}) => {
  return (
    <>
      {diceData?.space_result === "Double" ? (
        <DoublesDiceScreen
          screens={screens}
          diceData={diceData}
          roomId={roomId}
          currentPlayer={currentPlayer}
          discard_pile={discard_pile}
          OtherPlayers={OtherPlayers}
          playersWithCard={playersWithCard}
          playersWithCardInfo={playersWithCardInfo}
          playerSelected={playerSelected}
          cardSelected={cardSelected}
          buzzer_sound={buzzer_sound}
          default_audio_effect={default_audio_effect}
        />
      ) : diceData?.space_result === "Cover Up" ? (
        <CoverUpScreen
          screens={screens}
          CoverUpData={CoverUpData}
          roomId={roomId}
          currentPlayer={currentPlayer}
          buzzer_sound={buzzer_sound}
          default_audio_effect={default_audio_effect}
        />
      ) : (
        <DiscoveryScreen
          screens={screens}
          roomId={roomId}
          currentPlayer={currentPlayer}
          diceData={diceData}
          discard_pile={discard_pile}
          playersWithCard={playersWithCard}
          OtherPlayers={OtherPlayers}
          playersWithCardInfo={playersWithCardInfo}
          playerSelected={playerSelected}
          cardSelected={cardSelected}
          stealButton={stealButton}
          buzzer_sound={buzzer_sound}
          default_audio_effect={default_audio_effect}
        />
      )}
    </>
  );
};

export default ActivePlayer;
